import Vue from 'vue';
export const EventBus = new Vue();  // Creating a Vue instance to serve as the event bus
